<template>
    <div>
        <app-sub-title :text="'Comercio: ' + selectedStore.name "></app-sub-title>
        <b-btn variant="primary" @click="$router.push({name: 'storesPage'})"><i class="fa fa-arrow-left"></i></b-btn>
        <b-tabs>
            <b-tab title="Información">
                <br>
                <app-card-store :store="selectedStore" />
            </b-tab>
            <b-tab title="Foto">
                <br>
                <app-photo-store :store="selectedStore" />
            </b-tab>
            <b-tab title="Teléfonos" >
                <br>
                <app-phones-store :store="selectedStore" />
            </b-tab>
            <b-tab title="Categorias" >
                <br>
                <app-categories-store :store="selectedStore" />
            </b-tab>
            <!-- <b-tab title="Promociones">
                <br>
            </b-tab> -->
            <b-tab title="Ubicación">
                <br>
                <app-location-store :store="selectedStore" />
            </b-tab>
            <b-tab title="Modificar información general">
                <br>
                <app-update-general-information-store :store="selectedStore" :key="`ugi-${parseInt(Math.random() * 100000000)}`" />
            </b-tab>
        </b-tabs>
    </div>
</template>
<script>
import storeRepository from '../../../../repositories/stores.repository.js';
import CardStore from '../CardStore/CardStore';
import PhotoStore from '../PhotoStore/PhotoStore';
import PhonesStore from '../PhonesStore/PhonesStore';
import LocationStore from '../LocationStore/LocationStore';
import CategoriesStore from '../CategoriesStore/CategoriesStore';
import UpdateGeneralInformationStore from '../UpdateGeneralInformationStore/UpdateGeneralInformationStore';
import {mapGetters, mapMuttations} from 'vuex';

export default {
    components: {
        appCardStore: CardStore,
        appPhotoStore: PhotoStore,
        appPhonesStore: PhonesStore,
        appLocationStore: LocationStore,
        appCategoriesStore: CategoriesStore,
        appUpdateGeneralInformationStore: UpdateGeneralInformationStore
    },
    computed: {
        ...mapGetters(['selectedStore'])
    }
}
</script>
